import { Pipe, PipeTransform } from '@angular/core';
import { SubmittalStatusReason } from '../models/submittal-status-reason.model';

@Pipe({
    name: 'submittalStatusReasonFilter',
    standalone: true
})
export class SubmittalStatusReasonFilterPipe implements PipeTransform {
    transform(list: SubmittalStatusReason[], submittalStatusId: number): SubmittalStatusReason[] {
        if (!list || list.length === 0 || !submittalStatusId) {
            return [];
        }

        const reasons = list.filter((s) => s.submittalStatusId === submittalStatusId);
        return reasons.map((r) => {
            // Convert: (Offer Accepted) No Start -> No Start -- removes anything in parenthesis
            r.reason = r.reason.slice(r.reason.indexOf(') ') + 1, r.reason.length).trim();
            return r;
        });
    }
}
